// extracted by mini-css-extract-plugin
export var grid = "_t-0";
export var span1 = "_t-2";
export var span10 = "_t-b";
export var span10L = "_t-z";
export var span10M = "_t-n";
export var span10Xl = "_t-1b";
export var span11 = "_t-c";
export var span11L = "_t-10";
export var span11M = "_t-o";
export var span11Xl = "_t-1c";
export var span12 = "_t-d";
export var span12L = "_t-11";
export var span12M = "_t-p";
export var span12Xl = "_t-1d";
export var span1L = "_t-q";
export var span1M = "_t-e";
export var span1Xl = "_t-12";
export var span2 = "_t-3";
export var span2L = "_t-r";
export var span2M = "_t-f";
export var span2Xl = "_t-13";
export var span3 = "_t-4";
export var span3L = "_t-s";
export var span3M = "_t-g";
export var span3Xl = "_t-14";
export var span4 = "_t-5";
export var span4L = "_t-t";
export var span4M = "_t-h";
export var span4Xl = "_t-15";
export var span5 = "_t-6";
export var span5L = "_t-u";
export var span5M = "_t-i";
export var span5Xl = "_t-16";
export var span6 = "_t-7";
export var span6L = "_t-v";
export var span6M = "_t-j";
export var span6Xl = "_t-17";
export var span7 = "_t-8";
export var span7L = "_t-w";
export var span7M = "_t-k";
export var span7Xl = "_t-18";
export var span8 = "_t-9";
export var span8L = "_t-x";
export var span8M = "_t-l";
export var span8Xl = "_t-19";
export var span9 = "_t-a";
export var span9L = "_t-y";
export var span9M = "_t-m";
export var span9Xl = "_t-1a";
export var stretch = "_t-1";